
// Definición de defaults

export const defaultTipoPromocion: TipoPromocionProps = {
    idTipoPromocion:  0,
    descripcion:    '',
    activo:         false,
};

// Creación de interfaces

export interface TipoPromocionProps{
    idTipoPromocion:  number;
    descripcion:    string;
    activo:         boolean;
}
